"use strict";Object.defineProperty(exports, "__esModule", {value: true});var _reselect = require('reselect');

exports.createSelector = _reselect.createSelector;
